export const DASHBOARD_MOBILE_WIDTH = 780
